import { getUserSession } from 'ui-smartforce-settings';
import { apiGet } from '../Helpers';
import {
  ProjectsDashboardResponse,
  ProjectsTotals
} from '../Models/ProjectValue';
import { APP_CONTACTS_API_BASE_URL } from '../Constants/Url';

export const getProjectsReports =
  async (): Promise<ProjectsDashboardResponse> => {
    const url = `${APP_CONTACTS_API_BASE_URL}/projects/reports?limit=5`;
    const token = getUserSession().access_token;

    return apiGet<ProjectsDashboardResponse>(url, token);
  };

export const getNextProjectsReports = async (
  url: string
): Promise<ProjectsDashboardResponse> => {
  return apiGet(url, getUserSession().access_token);
};

export const getTotals = async (): Promise<ProjectsTotals> => {
  const url: string = `${APP_CONTACTS_API_BASE_URL}/projects/calculate-totals`;
  return apiGet(url, getUserSession().access_token);
};
